<template>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { watch } from "vue";
import { useRouter } from "vue-router";

const { isAuthenticated } = useAuth0();

const router = useRouter();

watch(() => isAuthenticated, (v) => {
  if (v) {
    router.replace('/knowledge-sources');
  }
}, { immediate: true })

</script>

<style scoped>

</style>